
export const FORM_VALIDATE = {
  "shopId": {
    rules: {
      required: true,
    },
    messages: {
      required: "warning_messages.shop_id_is_request",
    },
    alert: "warning_messages.shop_id_is_request",
  },
  "shopName": {
    rules: {
      required: true,
    },
    messages: {
      required: "warning_messages.shop_name_is_request",
    },
    alert: "warning_messages.shop_name_is_request",
  },
  "status": {
    rules: {
      required: true,
    },
    messages: {
      required: "warning_messages.status_is_required",
    },
    alert: "warning_messages.status_is_required",
  },
}

